// extracted by mini-css-extract-plugin
export default {"cardWrapper":"styles_cardWrapper__Ia8X8","avatarWrapper":"styles_avatarWrapper__nCtEF","info":"styles_info__wGU6y","status":"styles_status__Sm-ul"};